var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"base-radio radio",class:{checked: _vm.checked}},[_c('input',{attrs:{"type":"radio"},domProps:{"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('span',{staticClass:"radio-check"}),_c('span',{staticClass:"radio-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }